import React, { Fragment } from "react";
import ProtocolDropDown from "../products/ProtocolDropDown";

export default function ProtocolFilter({ company_id, protocol_id, onChange, title, onProtocolsLoaded }) {
  return (
    <Fragment>
      <label>{title || I18n.t("protocol_name")}</label>
      <ProtocolDropDown
        company_id={company_id}
        onProtocolChange={onChange}
        value={protocol_id}
        blankLabel={I18n.t("select_protocol")}
        onProtocolsLoaded={onProtocolsLoaded}
        includeBlank={true}
      />
    </Fragment>
  );
}

